import DataTable from "../../components/common/table";
import {
    Breadcrumb,
    Button,
    Form,
    Modal,
    Select,
    Space,
    Tag,
    Image,
    Popconfirm,
    message,
    Spin,
    Descriptions,
    Popover,
    Divider,
    InputNumber,
    Input,
    Tabs,
    Card,
    Statistic,
    Row,
    Col,
    Dropdown
} from "antd";
import Placeholder from "../../assets/placeholder.png";
import {Link} from "react-router-dom";
import {hasAccess, hasPayrollAccess, PAYROLL_OFFICER} from "../../helpers/roles";
import { userStore } from "../../store/userStore";
import {GrPaypal} from "react-icons/gr";
import {BiMinus,BiPlus} from "react-icons/bi";
import {BsCalendar4,BsThreeDotsVertical,BsCheck2Circle} from "react-icons/bs"
import Header from "../../components/dashboard/header";
import {
    DashboardOutlined,
    EyeOutlined,
    DeleteOutlined,
    PlusSquareOutlined,
    CheckOutlined,
    FilePdfOutlined,
    DownloadOutlined,
    FileExcelOutlined
} from "@ant-design/icons";
import {useState, useEffect,useRef} from "react";
import {NAIRA, MONTHS} from "../../defaults/utilities";
import {formatCurrency} from "../../helpers/currency";
import {scrollToTop} from "../../helpers/dom";
import {
    useCreateSinglePayroll,
    useDeductPayroll,
    useDeleteSinglePayroll,
    useGetPayrollData,
    useSettleMonthPayroll,
    useSettleUserPayroll,
    useTopPayroll,
    useGetAdjustmentHistory,
    useGetAdjustmentSummary,
    useGetPayrollAdjustments,
    useDownloadBeneficiaryReport,
    useDownloadSummaryReport,
    useDownloadParticularsReport
} from "../../hooks/payroll/payrollQuery";
import {
    useGetPayslip,
    useDownloadPayslip,
    useGetBulkPayslips,
    useDownloadBulkPayslips,
    useDownloadSalaryTable
} from "../../hooks/payroll/payslipQuery";
import PayslipModal from "../../components/payroll/PayslipModal";
import BulkPayslipDownload from "../../components/payroll/BulkPayslipDownload";
import DownloadSalaryTableButton from "../../components/payroll/DownloadSalaryTableButton";
import {useFetchAllFinancialYears} from "../../hooks/financialYear/financialYearQuery";
import {useFetchUsers, useSearchUsers} from "../../hooks/user/userQuery";
const {Option} = Select;




const PopoverContent = ({config})=>{

    const settlePayroll = useSettleMonthPayroll();


    const handleSettleAllUsers = async ()=>{
        const payload = {
            payrollConfig:config.id
        }
        await settlePayroll(payload);
        message.success("Payroll for Month settled successfully")
    }

    return(
        <>
            <div style={{
                display:"flex",
                flexDirection:"column"
            }}>
                <div>
                    <Button type="ghost" onClick={handleSettleAllUsers}>
                    <BsCheck2Circle/>
                        <b>Settle Payroll</b>
                    </Button>
                </div>
            </div>
        </>
    )
}

function PayrollEdit({payroll, config, onOperation}) {
    const [isOpen, setIsOpen] = useState(false);

    const [deductionModalOpen,setDeductionModaOpen] = useState(false);
    const [additionModalOpen,setAdditionModalOpen] = useState(false);
    
    // Form inputs for adjustments
    const [deductionAmount, setDeductionAmount] = useState('');
    const [deductionReason, setDeductionReason] = useState('');
    const [additionAmount, setAdditionAmount] = useState('');
    const [additionReason, setAdditionReason] = useState('');
    const [payslipModalOpen, setPayslipModalOpen] = useState(false);

    const deletePayroll = useDeleteSinglePayroll();
    const settlePayroll = useSettleUserPayroll();
    const deductPayroll = useDeductPayroll();
    const topPayroll = useTopPayroll();


    const handleOpenModal = () => setIsOpen(true);
    const handleCancelModal = () => setIsOpen(false);

    const confirmDelete = async () => {
        await deletePayroll(payroll.id);
        message.success("Payroll removed successfully")
    };

    const settleUserPayroll = async () => {
        const payload = {
            payroll: payroll.id
        }
        await settlePayroll(payload);
        message.success("User payroll settled");
        setIsOpen(false);

        onOperation && onOperation()
    }






    const handleDeduction = async ()=>{
        if (!deductionAmount || parseFloat(deductionAmount) <= 0) {
            message.error('Please enter a valid deduction amount');
            return;
        }
        
        if (!deductionReason || deductionReason.trim().length < 3) {
            message.error('Please provide a detailed reason for deduction (minimum 3 characters)');
            return;
        }
        
        const payload = {
            payrollId: payroll.id,
            amount: parseFloat(deductionAmount.toString().replace(/,/g, '')),
            reason: deductionReason.trim()
        }
        await deductPayroll(payload);
        setDeductionModaOpen(false);
        setDeductionAmount('');
        setDeductionReason('');
        setIsOpen(false);
        message.success("Payroll deducted successfully");

        onOperation && onOperation()
    }


    const handleAddition = async ()=>{
        if (!additionAmount || parseFloat(additionAmount) <= 0) {
            message.error('Please enter a valid addition amount');
            return;
        }
        
        if (!additionReason || additionReason.trim().length < 3) {
            message.error('Please provide a detailed reason for addition (minimum 3 characters)');
            return;
        }
        
        const payload = {
            payrollId: payroll.id,
            amount: parseFloat(additionAmount.toString().replace(/,/g, '')),
            reason: additionReason.trim()
        }
        await topPayroll(payload);
        setAdditionModalOpen(false);
        setAdditionAmount('');
        setAdditionReason('');
        setIsOpen(false);
        message.success("Payroll added successfully");

        onOperation && onOperation()
    }

    const openPayslipModal = () => {
        setPayslipModalOpen(true);
    };

    const closePayslipModal = () => {
        setPayslipModalOpen(false);
    };


    return (
        <>
            <Space size={'small'} wrap>
                <Button type="primary" style={{backgroundColor: "green"}} onClick={handleOpenModal}>
                    <EyeOutlined/>
                    View
                </Button>
                <Button type="primary" onClick={openPayslipModal}>Slip</Button>
            </Space>
            <Modal open={isOpen} centered title="User Payroll Information" width={700} footer={null}
                   onCancel={handleCancelModal}>
                <div style={{
                    marginTop: "3em",
                    maxHeight: "75vh",
                    overflowY: "scroll",
                    paddingLeft: "1em",
                    paddingRight: "1em"
                }}>
                    <div style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                    }}>
                        <div>
                            <Image
                                style={{
                                    borderRadius: "4px"
                                }}
                                width={100}
                                height={100}
                                src={Placeholder}
                            />
                        </div>
                        <Descriptions column={1} style={{
                            width: "22em"
                        }}>
                            <Descriptions.Item label="Name">
                                {payroll.user?.name}
                            </Descriptions.Item>
                            <Descriptions.Item label="User Id">
                                {payroll.user?.userId}
                            </Descriptions.Item>
                        </Descriptions>
                    </div>
                    <div style={{
                        marginTop: "1em"
                    }}>
                        <Descriptions bordered layout="horizontal" column={1}>
                            <Descriptions.Item label="Gross Amount">
                                {`${NAIRA} ${formatCurrency(payroll.gross)}`}
                            </Descriptions.Item>
                            <Descriptions.Item label="Deduction">
                                {`${NAIRA} ${formatCurrency(payroll.deduction)}`}
                            </Descriptions.Item>
                            <Descriptions.Item label="Amount">
                                <b>{`${NAIRA} ${formatCurrency(payroll.netTotal)}`}</b>
                            </Descriptions.Item>
                            <Descriptions.Item label="settled">
                                {payroll.settled ? <Tag color="green">Settled</Tag> :
                                    <Tag color="yellow"> Not Settled</Tag>}
                            </Descriptions.Item>
                            <Descriptions.Item label="Date Created">
                                {new Date(payroll.creationTime).toDateString()}
                            </Descriptions.Item>
                            <Descriptions.Item label="Settlement Date">
                                {payroll.settlementDate ?? "Date not set"}
                            </Descriptions.Item>
                        </Descriptions>
                    </div>
                    <div style={{
                        marginTop: "2em",
                        display: "flex",
                        justifyContent: "flex-end"
                    }}>
                        <Space>
                            {
                                !payroll.settled && !config?.finalApproved && hasAccess(userStore(state => state.user).roles, [PAYROLL_OFFICER]) &&
                                <>
                                <Button type="primary" style={{backgroundColor: "green"}} onClick={settleUserPayroll}>
                                    <CheckOutlined/>
                                    Settle
                                </Button>
                                <Button type="primary" onClick={()=>setAdditionModalOpen(true)}>
                                    <BiPlus/>
                                    Top Payroll
                                </Button>
                                <Button type="primary" style={{
                                    backgroundColor:"orange"
                                }} onClick={()=>setDeductionModaOpen(true)}>
                                    <BiMinus style={{
                                        color:"white"
                                    }}/>
                                    Deduct Payroll
                                </Button>
                                </>
                            }
                            {hasAccess(userStore(state => state.user).roles, [PAYROLL_OFFICER]) && (
                                <Popconfirm
                                    title="Delete this payroll"
                                    description="Are you sure to delete this record?"
                                    onConfirm={confirmDelete}
                                    onCancel={() => null}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button type="primary" danger disabled={config?.finalApproved || payroll.settled}>
                                        <DeleteOutlined/>
                                        Delete Payroll
                                    </Button>
                                </Popconfirm>
                            )}
                        </Space>
                    </div>
                </div>
            </Modal>


            {/* TOPPING AND DEDUCTION OF PAYROLL */}
            <Modal 
                title="Deduct from Payroll" 
                open={deductionModalOpen} 
                onCancel={()=>setDeductionModaOpen(false)} 
                footer={null}
                width={500}
            >
                <Form layout="vertical" style={{ marginTop: '1em' }}>
                    <Form.Item 
                        label="Deduction Amount" 
                        rules={[{ required: true, message: 'Please enter deduction amount' }]}
                    >
                        <InputNumber 
                            value={deductionAmount}
                            onChange={setDeductionAmount}
                            prefix={NAIRA} 
                            style={{ width: "100% " }}
                            placeholder="Enter amount to deduct"
                            min={0}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                        />
                    </Form.Item>
                    <Form.Item 
                        label="Reason for Deduction" 
                        rules={[{ required: true, message: 'Please provide reason for deduction' }]}
                    >
                        <Input.TextArea 
                            value={deductionReason}
                            onChange={(e) => setDeductionReason(e.target.value)}
                            placeholder="Enter detailed reason for this deduction (e.g., Unauthorized absence, disciplinary action, etc.)"
                            rows={3}
                            maxLength={500}
                            showCount
                        />
                    </Form.Item>
                    <Form.Item style={{ textAlign: 'right', marginTop: '1.5em' }}>
                        <Space>
                            <Button onClick={() => setDeductionModaOpen(false)}>
                                Cancel
                            </Button>
                            <Button type="primary" danger onClick={handleDeduction}>
                                Deduct Amount
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal 
                title="Add to Payroll" 
                open={additionModalOpen} 
                onCancel={()=>setAdditionModalOpen(false)} 
                footer={null}
                width={500}
            >
                <Form layout="vertical" style={{ marginTop: '1em' }}>
                    <Form.Item 
                        label="Addition Amount" 
                        rules={[{ required: true, message: 'Please enter addition amount' }]}
                    >
                        <InputNumber 
                            value={additionAmount}
                            onChange={setAdditionAmount}
                            prefix={NAIRA} 
                            style={{ width: "100%" }}
                            placeholder="Enter amount to add"
                            min={0}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                        />
                    </Form.Item>
                    <Form.Item 
                        label="Reason for Addition" 
                        rules={[{ required: true, message: 'Please provide reason for addition' }]}
                    >
                        <Input.TextArea 
                            value={additionReason}
                            onChange={(e) => setAdditionReason(e.target.value)}
                            placeholder="Enter detailed reason for this addition (e.g., Performance bonus, overtime payment, etc.)"
                            rows={3}
                            maxLength={500}
                            showCount
                        />
                    </Form.Item>
                    <Form.Item style={{ textAlign: 'right', marginTop: '1.5em' }}>
                        <Space>
                            <Button onClick={() => setAdditionModalOpen(false)}>
                                Cancel
                            </Button>
                            <Button type="primary" style={{ backgroundColor: "green" }} onClick={handleAddition}>
                                Add Amount
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Modal>

            {/* Payslip Modal */}
            <PayslipModal
                visible={payslipModalOpen}
                onCancel={closePayslipModal}
                userId={payroll.user?.id}
                financialYearId={payroll.financialYear?.id}
                yearMonth={payroll.yearMonth[1]}
                employeeName={payroll.user?.name}
                yearValue={payroll.yearMonth[0]}
                monthName={MONTHS.find(m => m.value === parseInt(payroll.month))?.name}
            />
        </>
    )
}


export default function Payroll() {
    const user = userStore(state => state.user);
    const hasAccess = hasPayrollAccess(user?.roles);

    const [isOpen, setIsOpen] = useState(false);
    const [year, setYear] = useState("");
    const [month, setMonth] = useState("");
    const [selectUser, setSelectedUser] = useState("");
    const [data, setData] = useState([]);
    const [config,setConfig] = useState({});
    const [searched, setSearched] = useState(false);
    const [loading, setLoading] = useState(false);
    const [m, setM] = useState(null);
    const [y, setY] = useState(null);
    const [userSearchResults, setUserSearchResults] = useState([]);
    const [userSearchText, setUserSearchText] = useState("");
    const [searchingUsers, setSearchingUsers] = useState(false);
    
    // Adjustment history state
    const [activeTab, setActiveTab] = useState("payroll");
    const [adjustmentHistory, setAdjustmentHistory] = useState([]);
    const [adjustmentSummary, setAdjustmentSummary] = useState(null);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);



    const handleOpen = () => setIsOpen(true);
    const handleClose = () => {
        setIsOpen(false);
        setUserSearchResults([]);
        setUserSearchText("");
    }

    const payrollDataColumns = [
        {
            title: "S/N",
            key: "s/n",
            render: (_, __, idx) => idx + 1
        },
        {
            title: "User Id",
            key: "userId",
            dataIndex: "user",
            render: ({userId}) => userId
        },
        {
            title: "Settled",
            key: "settled",
            dataIndex: "settled",
            render: (settled) => settled ? <Tag color="green">Settled</Tag> : <Tag color="red">Not Settled</Tag>
        },
        {
            title: "Settlement Date",
            key: "settlementDate",
            dataIndex: "settlementDateString",
            render: (d) => d !== null ? (new Date(d).toDateString()) : "Date Not set"
        },
        {
            title: "Total",
            key: "total",
            dataIndex: "netTotal",
            render: (total) => `${NAIRA} ${formatCurrency(total)}`
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, payroll) => <PayrollEdit payroll={payroll} config={config} onOperation={() => handleRefreshData()}/>
        }
    ];



    useEffect(() => {
        scrollToTop();
    }, []);


    const getPayrolls = useGetPayrollData();
    const createPayroll = useCreateSinglePayroll();
    const searchUsers = useSearchUsers();
    const {years} = useFetchAllFinancialYears();
    const getAdjustmentHistory = useGetAdjustmentHistory();
    const getAdjustmentSummary = useGetAdjustmentSummary();
    const downloadBeneficiaryReport = useDownloadBeneficiaryReport();
    const downloadSummaryReport = useDownloadSummaryReport();
    const downloadParticularsReport = useDownloadParticularsReport();
    const downloadBulkPayslips = useDownloadBulkPayslips();
    const downloadSalaryTable = useDownloadSalaryTable();


    const handleYearSearch = async (value) => {
        setY(value);

        if (!m)
            return

        !searched && setSearched(true)
        setY(value);
        setLoading(true)
        try {
            const match = await getPayrolls(value, m);
            if (match && match.data) {
                setData(match.data.content || []);
                setConfig({...match.payrollConfig});
            } else {
                setData([]);
                setConfig({});
                message.warning("No payroll data found");
            }
        } catch (error) {
            console.error("Error fetching payroll data:", error);
            message.error("Failed to fetch payroll data");
            setData([]);
            setConfig({});
        } finally {
            setLoading(false);
        }
    }


    const handleMonthSearch = async (value) => {
        !searched && setSearched(true)
        setM(value)

        if (!y)
            return

        setLoading(true);
        try {
            const match = await getPayrolls(y, value);
            if (match && match.data) {
                setData(match.data.content || []);
                setConfig({...match.payrollConfig});
            } else {
                setData([]);
                setConfig({});
                message.warning("No payroll data found");
            }
        } catch (error) {
            console.error("Error fetching payroll data:", error);
            message.error("Failed to fetch payroll data");
            setData([]);
            setConfig({});
        } finally {
            setLoading(false);
        }
    }

    const handleCreatePayroll = async () => {
        const payload = {
            userId: selectUser,
            financialYear: year,
            month
        }

        try {
            await createPayroll(payload);
            setIsOpen(false);
            message.success("User added to payroll successfully");

            setLoading(true);
            if (y && m) {
                const results = await getPayrolls(y, m);
                if (results && results.data) {
                    setData(results.data.content || []);
                    setConfig({...results.payrollConfig});
                } else {
                    setData([]);
                    setConfig({});
                }
            }
        } catch (error) {
            console.error("Error creating payroll:", error);
            message.error("Failed to add user to payroll");
        } finally {
            setLoading(false);
            // Reset user search state
            setUserSearchResults([]);
            setUserSearchText("");
        }
    }

    const handleUserSearch = async (value) => {
        setUserSearchText(value);
        if (value.trim().length < 2) {
            setUserSearchResults([]);
            return;
        }

        setSearchingUsers(true);
        try {
            const results = await searchUsers(value);
            console.log(results);
            setUserSearchResults(results || []);
        } catch (error) {
            console.error("Error searching users:", error);
            message.error("Failed to search users");
        } finally {
            setSearchingUsers(false);
        }
    };

    const handleRefreshData = async () => {
        if (y && m) {
            setLoading(true);
            try {
                const results = await getPayrolls(y, m);
                if (results && results.data) {
                    setData(results.data.content || []);
                    setConfig({...results.payrollConfig});
                } else {
                    setData([]);
                    setConfig({});
                }
            } catch (error) {
                console.error("Error refreshing payroll data:", error);
                message.error("Failed to refresh payroll data");
            } finally {
                setLoading(false);
            }
        }
    };

    const loadAdjustmentHistory = async (page = 0) => {
        if (y && m) {
            setHistoryLoading(true);
            try {
                const results = await getAdjustmentHistory(y, m, page, 20);
                if (results) {
                    setAdjustmentHistory(results.content || []);
                    setTotalPages(results.totalPages || 0);
                    setTotalElements(results.totalElements || 0);
                    setCurrentPage(page);
                } else {
                    setAdjustmentHistory([]);
                    setTotalPages(0);
                    setTotalElements(0);
                }
            } catch (error) {
                console.error("Error loading adjustment history:", error);
                message.error("Failed to load adjustment history");
            } finally {
                setHistoryLoading(false);
            }
        }
    };

    const loadAdjustmentSummary = async () => {
        if (y && m) {
            try {
                const summary = await getAdjustmentSummary(y, m);
                setAdjustmentSummary(summary);
            } catch (error) {
                console.error("Error loading adjustment summary:", error);
                setAdjustmentSummary(null);
            }
        }
    };

    const handleTabChange = (key) => {
        setActiveTab(key);
        if (key === "adjustments" && y && m) {
            loadAdjustmentHistory(0);
            loadAdjustmentSummary();
        }
    };

    const handleDownloadBeneficiaryReport = async () => {
        if (!y) {
            message.error('Please select a financial year first');
            return;
        }
        try {
            message.loading('Downloading beneficiary report...', 0);
            await downloadBeneficiaryReport(y, m);
            message.destroy();
            message.success('Beneficiary report downloaded successfully');
        } catch (error) {
            message.destroy();
            message.error('Failed to download beneficiary report');
        }
    };

    const handleDownloadSummaryReport = async () => {
        if (!y) {
            message.error('Please select a financial year first');
            return;
        }
        try {
            message.loading('Downloading summary report...', 0);
            await downloadSummaryReport(y);
            message.destroy();
            message.success('Summary report downloaded successfully');
        } catch (error) {
            message.destroy();
            message.error('Failed to download summary report');
        }
    };

    const handleDownloadParticularsReport = async () => {
        if (!y || !m) {
            message.error('Please select both financial year and month first');
            return;
        }
        try {
            message.loading('Downloading particulars report...', 0);
            await downloadParticularsReport(y, m);
            message.destroy();
            message.success('Particulars report downloaded successfully');
        } catch (error) {
            message.destroy();
            message.error('Failed to download particulars report');
        }
    };

    const handleDownloadBulkPayslips = async () => {
        try {
            await downloadBulkPayslips(y, m);
            message.success('Bulk payslips download initiated');
        } catch (error) {
            message.error('Failed to download bulk payslips');
        }
    };

    const handleDownloadSalaryTable = async () => {
        try {
            await downloadSalaryTable(y, m);
            message.success('Salary table downloaded successfully');
        } catch (error) {
            message.error('Failed to download salary table');
        }
    };

    const adjustmentHistoryColumns = [
        {
            title: "S/N",
            key: "s/n",
            width: 60,
            render: (_, __, idx) => (currentPage * 20) + idx + 1
        },
        {
            title: "Employee",
            key: "employee",
            render: (_, record) => (
                <div>
                    <div><strong>{record.employeeName}</strong></div>
                    <div style={{ fontSize: '12px', color: '#666' }}>{record.employeeUserId}</div>
                </div>
            )
        },
        {
            title: "Type",
            key: "adjustmentType",
            dataIndex: "adjustmentType",
            width: 100,
            render: (type) => (
                <Tag color={type === 'ADDITION' ? "green" : "red"}>
                    {type}
                </Tag>
            )
        },
        {
            title: "Amount",
            key: "amount",
            dataIndex: "amount",
            width: 120,
            render: (amount) => `${NAIRA} ${formatCurrency(amount)}`
        },
        {
            title: "Previous Total",
            key: "previousNetTotal",
            dataIndex: "previousNetTotal",
            width: 130,
            render: (amount) => `${NAIRA} ${formatCurrency(amount)}`
        },
        {
            title: "New Total",
            key: "newNetTotal",
            dataIndex: "newNetTotal",
            width: 130,
            render: (amount) => `${NAIRA} ${formatCurrency(amount)}`
        },
        {
            title: "Reason",
            key: "reason",
            dataIndex: "reason",
            ellipsis: true,
            render: (reason) => (
                <span title={reason}>{reason}</span>
            )
        },
        {
            title: "Adjusted By",
            key: "adjustedBy",
            dataIndex: "adjustedBy",
            width: 120
        },
        {
            title: "Date",
            key: "adjustedAt",
            dataIndex: "adjustedAt",
            width: 100,
            render: (date) => new Date(date).toLocaleDateString()
        }
    ];



    return (
        <>
            <div className="main-container">
                <Header/>
                <div className="main-body">

                    <div className="info-bar">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <DashboardOutlined className="dashboard-icon"/>
                                <Link to={"/dashboard"}>Dashboard</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <GrPaypal/>
                                <Link to={"/payroll"}>Payroll</Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "30em"
                        }}>
                            <div>
                                <Select
                                    showSearch
                                    placeholder="Filter By Year"
                                    onChange={handleYearSearch}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    style={{
                                        width: "10em"
                                    }}
                                    options={[
                                        ...years.map((year) => ({value: year.id, label: year.value}))
                                    ]
                                    }
                                />
                            </div>
                            <div>
                                <Select
                                    showSearch
                                    placeholder="Filter By Month"
                                    onChange={handleMonthSearch}
                                    disabled={!y}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    style={{
                                        width: "10em"
                                    }}
                                    options={[...MONTHS.map(month => ({value: month.value, label: month.name}))]}
                                />
                            </div>
                        </div>
                        {hasAccess && (
                            <div style={{display: 'flex', gap: '0.5em', flexWrap: 'wrap'}}>
                                <Button style={{backgroundColor: "green", color: "#FFFFFF"}} onClick={handleOpen}>
                                    <PlusSquareOutlined/>
                                    Add User
                                </Button>
                                {searched && y && m && (
                                    <>
                                        <Dropdown
                                            menu={{
                                                items: [
                                                    {
                                                        key: 'payslips',
                                                        label: 'Download All Payslips',
                                                        icon: <DownloadOutlined/>,
                                                        onClick: handleDownloadBulkPayslips
                                                    },
                                                    {
                                                        key: 'salary-table',
                                                        label: 'Download Salary Table',
                                                        icon: <FileExcelOutlined/>,
                                                        onClick: handleDownloadSalaryTable
                                                    },
                                                    {
                                                        type: 'divider'
                                                    },
                                                    {
                                                        key: 'beneficiary',
                                                        label: 'Beneficiary Report',
                                                        icon: <DownloadOutlined/>,
                                                        onClick: handleDownloadBeneficiaryReport
                                                    },
                                                    {
                                                        key: 'summary',
                                                        label: 'Summary Report',
                                                        icon: <DownloadOutlined/>,
                                                        onClick: handleDownloadSummaryReport
                                                    },
                                                    {
                                                        key: 'particulars',
                                                        label: 'Particulars Report',
                                                        icon: <DownloadOutlined/>,
                                                        onClick: handleDownloadParticularsReport
                                                    }
                                                ]
                                            }}
                                            disabled={loading || data.length === 0}
                                        >
                                            <Button type="primary" icon={<DownloadOutlined/>}>
                                                Downloads
                                            </Button>
                                        </Dropdown>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                    {searched && (
                        <>
                            <div className="info-bar" style={{justifyContent: "space-between"}}>
                                <div style={{
                                    backgroundColor: "green",
                                    marginTop: "0.2em",
                                    padding: "0.3em",
                                    width: "12em",
                                    borderRadius: "5px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "white"
                                }}>
                                    <BsCalendar4 style={{
                                        color: "white"
                                    }}/>
                                    <div style={{
                                        marginLeft: "0.5em",
                                        fontWeight: "bold",
                                        display: "flex",
                                        justifyContent: "space-evenly",
                                        width: "60%"
                                    }}>
                                        {
                                            searched && (
                                                <>
                                                    <span>{MONTHS.find((mth) => mth.value == m).name}</span>

                                                    <span>{years.find((idYear) => idYear.id == y)?.value}</span>
                                                </>
                                            )
                                        }
                                    </div>
                                </div>
                                {hasAccess && (
                                    <div>
                                        <Popover placement="top"  content={<PopoverContent config={config} />} trigger={"focus"}>
                                            <Button type="ghost">
                                                <BsThreeDotsVertical/>
                                            </Button>
                                        </Popover>
                                    </div>
                                )}
                            </div>
                        
                            <Tabs 
                                activeKey={activeTab} 
                                onChange={handleTabChange}
                                style={{ marginTop: '1em' }}
                                items={[
                                    {
                                        key: 'payroll',
                                        label: 'Payroll Data',
                                        children: (
                                            <div className="table-section">
                                                <Spin spinning={loading}>
                                                    <DataTable cols={payrollDataColumns} data={data}/>
                                                </Spin>
                                            </div>
                                        )
                                    },
                                    {
                                        key: 'adjustments',
                                        label: 'Adjustment History',
                                        children: (
                                            <div>
                                                {adjustmentSummary && (
                                                    <Card size="small" style={{ marginBottom: 16 }}>
                                                        <Row gutter={16}>
                                                            <Col span={6}>
                                                                <Statistic 
                                                                    title="Total Adjustments" 
                                                                    value={adjustmentSummary.totalAdjustments || 0} 
                                                                />
                                                            </Col>
                                                            <Col span={6}>
                                                                <Statistic 
                                                                    title="Additions" 
                                                                    value={adjustmentSummary.totalAdditions || 0}
                                                                    valueStyle={{ color: '#3f8600' }}
                                                                />
                                                            </Col>
                                                            <Col span={6}>
                                                                <Statistic 
                                                                    title="Deductions" 
                                                                    value={adjustmentSummary.totalDeductions || 0}
                                                                    valueStyle={{ color: '#cf1322' }}
                                                                />
                                                            </Col>
                                                            <Col span={6}>
                                                                <Statistic 
                                                                    title="Net Adjustment" 
                                                                    value={adjustmentSummary.netAdjustment || 0}
                                                                    formatter={value => `${NAIRA} ${formatCurrency(value)}`}
                                                                    valueStyle={{ color: (adjustmentSummary.netAdjustment || 0) >= 0 ? '#3f8600' : '#cf1322' }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                )}
                                                <div className="table-section">
                                                    <Spin spinning={historyLoading}>
                                                        <DataTable 
                                                            cols={adjustmentHistoryColumns} 
                                                            data={adjustmentHistory}
                                                            pagination={{
                                                                current: currentPage + 1,
                                                                total: totalElements,
                                                                pageSize: 20,
                                                                showSizeChanger: false,
                                                                onChange: (page) => loadAdjustmentHistory(page - 1)
                                                            }}
                                                        />
                                                    </Spin>
                                                </div>
                                            </div>
                                        )
                                    }
                                ]}
                            />
                        </>
                    )}
                </div>
            </div>
            <Modal open={isOpen} onCancel={handleClose} footer={null} title={'Add User To Payroll'}>
                <div style={{
                    marginTop: "3em",
                    maxHeight: "70vh",
                    overflowY: "scroll",
                    paddingLeft: "1em",
                    paddingRight: "1em"
                }}>
                    <Form>
                        <Form.Item label="Select User">
                            <Select
                                placeholder="Search and select a user"
                                onChange={(e) => setSelectedUser(e)}
                                loading={searchingUsers}
                                showSearch
                                filterOption={false}
                                onSearch={handleUserSearch}
                                value={selectUser}
                                notFoundContent={searchingUsers ? <Spin size="small" /> : (userSearchText.length >= 2 ? "No users found" : "Type at least 2 characters to search")}
                                style={{ width: '100%' }}
                            >
                                {
                                    userSearchResults.map((u, idx) => (
                                        <Option value={u.id} key={idx}>{u.userId} - {u.name}</Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item label="Financial Year">
                            <Select placeholder="Select Financial year" onChange={(e) => setYear(e)}>
                                {
                                    years.map((yr, idx) => (
                                        <Option value={yr.id} key={idx}>
                                            {yr.value}
                                        </Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item label="Month">
                            <Select placeholder="Select Month" onChange={(e) => setMonth(e)}>
                                {
                                    MONTHS.map((mn, idx) => (
                                        <Option key={idx} value={mn.value}>{mn.name}</Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item wrapperCol={{
                            span: 8,
                            offset: 16
                        }}
                                   className="submit-button-wrapper">
                            <Button type="primary" style={{
                                backgroundColor: "green"
                            }} onClick={handleCreatePayroll}>
                                Add To Payroll
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    )
}
